import React, { useState } from "react";
import "./style.css";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import parse from "html-react-parser";
import {
  Button, Snackbar, Alert, Dialog, Box, Collapse,
} from "@mui/material";

import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import ShoppingCartIcon from "@mui/icons-material/AddShoppingCart";
import VisibilityIcon from "@mui/icons-material/Visibility";
import PermContactCalendarIcon from "@mui/icons-material/PermContactCalendar";
import slugify from "../../Utils/slugify";
import Footer from "../../Components/Footer";
import ScrollToTop from "../../Components/scrollup";
import UseFetch from "../../hook/useFetch";
import BestBroduct from "../../Components/ProductRandom";
import ProductBrand from "../../Components/ProductBrand";
import { Helmet } from "react-helmet-async";
export default function ProductDetails({ onAddToCart }) {
  const { data, loading } = UseFetch("https://ebuy-backend-two.vercel.app/api/article");
  const produits = Array.isArray(data) ? data : [];

  const [couleurSelectionnee, setCouleurSelectionnee] = useState(null);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [displayDescr, setDisplayDescr] = useState(false);
  const [activeDialog, setActiveDialog] = useState(null); // 1 = image principale, 2 = -1, 3 = -2

  // --- Parsing URL ---
  const pathe = window.location.pathname.replace(/%20/g, " ");
  const segments = pathe.split("/");
  const [, , path1, path2, path3, path4, path5] = segments;

  const isProduct = (name) =>
    name && produits.some((p) => p.articleName === decodeURIComponent(name));

  // --- Produit courant (priorité path5 > path4 > path3) ---
const currentProduct = produits.find((p) => {
  const slug = slugify(p.articleName);

  if (path5) return slug === path5;
  if (path4) return slug === path4;
  if (path3) return slug === path3;

  return false;
});

  // --- Générateur d'URL Firebase selon le niveau de profondeur ---
  const getImgUrl = (suffix = "") => {
  if (!currentProduct) return "";

  const base =
    "https://firebasestorage.googleapis.com/v0/b/ebuy-10d2e.appspot.com/o/";

  const famille = encodeURIComponent(currentProduct.famille);
  const categorie = encodeURIComponent(currentProduct.categorie);
  const souscategorie = currentProduct.subcategorie
    ? encodeURIComponent(currentProduct.subcategorie)
    : null;

  const article = encodeURIComponent(currentProduct.articleName);

  let folderPath = "";

  // Niveau 5
  if (currentProduct.subSubcategorie) {
    const subSub = encodeURIComponent(currentProduct.subSubcategorie);

    folderPath =
      `${famille}%2F${categorie}%2F${souscategorie}%2F${subSub}%2F${subSub}%20${article}`;
  }

  // Niveau 4
  else if (currentProduct.subcategorie) {
    folderPath =
      `${famille}%2F${categorie}%2F${souscategorie}%2F${souscategorie}%20${article}`;
  }

  // Niveau 3
  else {
    folderPath =
      `${famille}%2F${categorie}%2F${categorie}%20${article}`;
  }

  return `${base}${folderPath}${suffix}.jpeg?alt=media`;
};
  // --- Ajout au panier ---
  const handleAddToCart = () => {
    if (!currentProduct) return;

    const existingCart = JSON.parse(localStorage.getItem("cart")) || [];

    const existingProductIndex = existingCart.findIndex(
      (item) => item.name === currentProduct.articleName
    );

    if (existingProductIndex !== -1) {
      existingCart[existingProductIndex].quantite += 1;
    } else {
      const price = currentProduct.prixPromo
        ? currentProduct.prixPromo
        : currentProduct.prixFlash
        ? currentProduct.prixFlash
        : currentProduct.prix;

      // img : clé textuelle comme l'ancien code (compatibilité avec le composant panier)
      existingCart.push({
        family: currentProduct.famille,
        name: currentProduct.articleName,
        img: `${decodeURIComponent(path2)} ${decodeURIComponent(path3)}`,
        categorie: currentProduct.categorie,
        souscategorie: currentProduct.subcategorie,
        subSubcategorie: currentProduct.subSubcategorie || "",
        price: Number(price).toFixed(3),
        brand: currentProduct.brand,
        reference: currentProduct.ref,
        livraisonGratuit: currentProduct.livraisonGratuit,
        quantite: 1,
        color: couleurSelectionnee,
      });
    }

    localStorage.setItem("cart", JSON.stringify(existingCart));
    setOpenSnackbar(true);
    // Pas de window.location.reload() — meilleure UX
    // Assurer la mise à jour du compteur panier via onAddToCart ou un event global
    if (onAddToCart) onAddToCart();
  };

  // --- Breadcrumbs : liens cliquables comme l'ancien code ---
  const formatSlugToText = (slug = "") =>
  decodeURIComponent(slug)
    .replace(/-/g, " ")
    .replace(/\b\w/g, (l) => l.toUpperCase());

const renderBreadcrumbs = () => {
  const parts = [
    { seg: path1, depth: 1 },
    { seg: path2, depth: 2 },
    { seg: path3, depth: 3 },
    { seg: path4, depth: 4 },
    { seg: path5, depth: 5 },
  ].filter((p) => p.seg);

  return parts.map(({ seg, depth }, i) => {
    const label = ` / ${formatSlugToText(seg)}`;

    const collectionHref = `/collections/${parts
      .slice(0, i + 1)
      .map((p) => p.seg)
      .join("/")}`;

    const produitHref = `/produit/${parts
      .slice(0, i + 1)
      .map((p) => p.seg)
      .join("/")}`;

    return isProduct(seg) ? (
      <a key={depth} href={produitHref}>
        {label}
      </a>
    ) : (
      <a key={depth} href={collectionHref}>
        {label}
      </a>
    );
  });
};

  // --- Images disponibles selon photoPlus ---
  const imagesSuffixes = ["", "-1", ...(currentProduct?.photoPlus ? ["-2"] : [])];
const productTitle = currentProduct
  ? `${currentProduct.articleName} | Ebuy Tunisie`
  : "Ebuy Tunisie";

const productDescription = currentProduct
  ? `${currentProduct.articleName} ${currentProduct.brand} disponible en Tunisie au meilleur prix chez Ebuy. Livraison rapide partout en Tunisie.`
  : "Ebuy Tunisie";

const productUrl = window.location.href;

const productImage = currentProduct
  ? getImgUrl("")
  : "https://www.ebuytn.com/logo_public64.png";
  return (
    <div className="products details" id="produits">
      <Helmet>
  <title>{productTitle}</title>

  <meta
    name="description"
    content={productDescription}
  />

  <meta
    name="keywords"
    content={`${currentProduct?.articleName}, ${currentProduct?.brand}, Tunisie, Ebuy`}
  />

  <link
    rel="canonical"
    href={productUrl}
  />

  {/* Open Graph */}
  <meta property="og:type" content="product" />
  <meta property="og:title" content={productTitle} />
  <meta property="og:description" content={productDescription} />
  <meta property="og:image" content={productImage} />
  <meta property="og:url" content={productUrl} />

  {/* Twitter */}
  <meta name="twitter:card" content="summary_large_image" />
  <meta name="twitter:title" content={productTitle} />
  <meta name="twitter:description" content={productDescription} />
  <meta name="twitter:image" content={productImage} />

  {/* Schema Product Google */}
  <script type="application/ld+json">
    {JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Product",
      name: currentProduct?.articleName,
      image: [productImage],
      description: productDescription,
      brand: {
        "@type": "Brand",
        name: currentProduct?.brand,
      },
      offers: {
        "@type": "Offer",
        priceCurrency: "TND",
        price:
          currentProduct?.prixPromo ||
          currentProduct?.prixFlash ||
          currentProduct?.prix,
        availability:
          currentProduct?.stock > 0
            ? "https://schema.org/InStock"
            : "https://schema.org/OutOfStock",
        url: productUrl,
      },
    })}
  </script>
</Helmet>
      <ScrollToTop />

      <div className="productDetails">
        {/* Breadcrumbs */}
        <span className="navbarCollection details">
          collections
          {renderBreadcrumbs()}
        </span>

        {loading ? (
          <div className="loader details"></div>
        ) : currentProduct ? (
          <div className="productContainDetail">
            <h2 className="pathTitle">
              {currentProduct.articleName}
              {currentProduct.nouveau === true && (
                <span className="newBadge">NOUVEAU</span>
              )}
            </h2>

            <div className="productcardDetails">
              {/* Carousel */}
              <Carousel
                className="custom-carousel"
                showArrows={false}
                showIndicators={false}
                showStatus={false}
                autoPlay={false}
              >
                {imagesSuffixes.map((suffix, i) => (
                  <div key={i} onClick={() => setActiveDialog(i + 1)}>
                    <img
                      className="cardDetails"
                      src={getImgUrl(suffix)}
                      alt={`${currentProduct.articleName} ${currentProduct.brand} Tunisie`}
                      title={currentProduct.articleName}
                    />
                  </div>
                ))}
              </Carousel>

              {/* Détails produit */}
              <div className="morecardDetailP">
                <h2>
                  {currentProduct.articleName} -{" "}
                  <a
                    href={`/${currentProduct.brand}`}
                    style={{ textDecoration: "none", color: "#F77171" }}
                  >
                    {currentProduct.brand}
                  </a>{" "}
                  {currentProduct.ref}
                </h2>

                {/* Prix — même logique que l'ancien code (flash > promo > livraisonGratuit > normal) */}
               <div className="priceBox">
                  {currentProduct.prixFlash ? (
                    <>
                      <span className="flashBadge">FLASH</span>
                      <h4 className="oldPrice">{currentProduct.prix.toFixed(0)} TND</h4>
                      <h4 className="flashPrice">{currentProduct.prixFlash.toFixed(0)} TND</h4>
                    </>
                  ) : currentProduct.prixPromo ? (
                    <>
                      <span className="promoBadge">PROMO</span>
                      <h4 className="oldPrice">{currentProduct.prix.toFixed(0)} TND</h4>
                      <h4 className="promoPrice">{currentProduct.prixPromo.toFixed(0)} TND</h4>
                    </>
                  ) : (
                    <h4 className="normalPrice">{currentProduct.prix.toFixed(0)} TND</h4>
                  )}
                  <span className="morecardDetailPrice">
                    {currentProduct.livraisonGratuit ? "🚚 Livraison Gratuite" : "+ frais de livraison 8 TND"}
                  </span>
                </div>

                {/* Couleurs / Textures */}
                {currentProduct.colors?.length > 0 && (
                  <div style={{width: '100%', marginTop: '20px'}}>
                    <span className="morecardDetailColor">Sélectionnez la texture :</span>
                    <div className="colorboisDiv">
                      {currentProduct.colors.map((color, idx) => (
                        <div 
                          key={idx} 
                          className={`colorOptionWrapper ${color === couleurSelectionnee ? "selected" : ""}`}
                          onClick={() => setCouleurSelectionnee(color)}
                        >
                          <img src={require(`../../images/colors/${color}.jpeg`)} alt={color} className="boisColor" />
                          <span className="colorName">{color.replace(/[^a-zA-Z\s]/g, "")}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                <Button 
                   variant="outlined" color="warning" endIcon={<VisibilityIcon />}
                  onClick={() => setDisplayDescr(!displayDescr)}
                  sx={{ mt: 3, textTransform: 'none', fontFamily: 'Exo', fontWeight: 600,width: "90%", mx: "auto",display: "flex",}} 
                >
                  Voir le descriptif technique
                </Button>

                <Collapse in={displayDescr} sx={{ width: '90%', mx: "auto" }}>
                  <Box className="descriptionCollapse">
                    {parse(currentProduct.descreption || "")}
                    {currentProduct.categorie !== "meubles" && <p><strong>Garantie : 1 an</strong></p>}
                  </Box>
                </Collapse>

                <Button
                  className="buyNowBtn"
                  variant="contained"
                   sx={{
    width: "80%",
    mx: "auto",
    display: "flex",
  }}
                  disabled={currentProduct.stock < 1}
                  startIcon={currentProduct.stock < 1 ? <LocalShippingIcon /> : <ShoppingCartIcon />}
                  onClick={handleAddToCart}
                >
                  <span className="buyText">{currentProduct.stock < 1 ? "EN ARRIVAGE" : "J'achète maintenant"}</span>
                </Button>

                <div className="profitDetail">
                  <Box sx={{ display: "flex", alignItems: 'center', gap: 1 }}>
                    <PermContactCalendarIcon fontSize="small" color="warning" />
                    <span

                            className="profitDetailspan"

                            style={{ marginLeft: "5px" }}

                          >

                            Pour plus d'informations! : appelez{" "} <a href="tel:27890006" className="info">27 890 006</a>
                    </span>
                  </Box>
                </div>
              </div>
            </div>
          </div>
        ) : null}
      </div>

      {/* Sélection et produits de la marque */}
      {currentProduct && (
        <div className="bestProductDiv">
          <h2>Notre sélection pour vous</h2>
          <BestBroduct
            categName={decodeURIComponent(path2)}
            currentProduct={currentProduct.articleName}
          />
          <h2>
            autres produits de la marque{" "}
            <span style={{ color: "#F77171" }}>{currentProduct.brand}</span>
          </h2>
          <ProductBrand
            currentProduct={decodeURIComponent(path3)}
            brand={currentProduct.brand}
          />
        </div>
      )}

      <Footer />

      {/* Dialogs de zoom — conditionnels (photoPlus pour le 3e) */}
      {imagesSuffixes.map((suffix, i) => (
        <Dialog
          key={i}
          open={activeDialog === i + 1}
          onClose={() => setActiveDialog(null)}
          sx={{ zIndex: 9999999 }}
        >
          <img
            src={getImgUrl(suffix)}
            alt={currentProduct?.articleName}
            style={{
              maxWidth: "100%",
              maxHeight: "80vh",
              objectFit: "contain",
            }}
          />
        </Dialog>
      ))}

      {/* Snackbar confirmation panier */}
      <Snackbar
        open={openSnackbar}
        autoHideDuration={5000}
        onClose={() => setOpenSnackbar(false)}
      >
        <Alert
          onClose={() => setOpenSnackbar(false)}
          severity="success"
          variant="filled"
          sx={{ width: "100%" }}
        >
          {currentProduct?.articleName} a été ajouté au panier !
        </Alert>
      </Snackbar>
    </div>
  );
}